export default __webpack_public_path__ + "static/water_bg-c9b4b2b4b5bf1b0b6864a079abf9f8e5.png";